import React, { useState } from 'react';
import Select from 'react-select';

const SELECT_STYLES = {
    control: base => ({ ...base, fontSize: 13, minHeight: 36, borderColor: '#e4e7ea', cursor: 'pointer' }),
    menuPortal: base => ({ ...base, zIndex: 9999 }),
};

const FieldsetBloquearVendedores = ({
    usuariosDisponiveis = [],
    vendedoresSelecionados = [],
    onAdicionar,
    onRemover,
}) => {
    const [usuarioSelecionado, setUsuarioSelecionado] = useState(null);

    const handleAdicionar = () => {
        if (!usuarioSelecionado) return;
        onAdicionar(usuarioSelecionado);
        setUsuarioSelecionado(null);
    };

    const optionsDisponiveis = usuariosDisponiveis
        .filter(u => !vendedoresSelecionados.map(v => v.value).includes(u.chave))
        .map(u => ({ label: u.valor, value: u.chave }));

    return (
        <div className="vx-config-card">
            <div className="vx-config-card-header">
                <i className="material-icons">person_off</i>
                <div className="vx-config-card-header-text">
                    <h6>Bloquear Vendedores</h6>
                    <small>Restrinja quais vendedores podem operar este itinerário</small>
                </div>
            </div>
            <div className="vx-config-card-body">
                <div className="vx-add-row vx-add-row-1">
                    <Select
                        placeholder="Adicionar vendedor..."
                        value={usuarioSelecionado}
                        onChange={setUsuarioSelecionado}
                        options={optionsDisponiveis}
                        styles={SELECT_STYLES}
                        noOptionsMessage={() => 'Nenhuma opção encontrada'}
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                    />
                    <button
                        type="button"
                        className="vx-btn-incluir"
                        onClick={handleAdicionar}
                        disabled={!usuarioSelecionado}
                    >
                        <i className="material-icons" style={{ fontSize: 14 }}>add</i> Incluir
                    </button>
                </div>

                <div className="vx-item-list">
                    {vendedoresSelecionados.length === 0
                        ? <div className="vx-item-list-empty">Nenhum vendedor bloqueado</div>
                        : vendedoresSelecionados.map((usuario, index) => (
                            <div key={index} className="vx-item-list-item">
                                <div className="vx-item-list-item-info">
                                    <span className="vx-item-list-item-label">{usuario.label}</span>
                                </div>
                                <button type="button" className="vx-item-list-remove"
                                    onClick={() => onRemover(usuario.value)}>
                                    <i className="material-icons" style={{ fontSize: 16 }}>close</i>
                                </button>
                            </div>
                        ))
                    }
                </div>
            </div>
        </div>
    );
};

export default FieldsetBloquearVendedores;
